<template>
  <v-app
    :style="{
      height: '100%',
      'background-image': 'url(' + require('@/assets/app/' + bgImg) + ')',
      'background-position': 'center',
      'background-attachment': 'fixed',
      'background-size': 'cover',
      '--colorBar': colorBar,
      '--btnColor': btnColor,
      '--inputText': dark ? 'white' : 'black',
    }"
  >
    <v-snackbar
      :timeout="6000"
      v-model="snackbar.mostrar"
      app
      centered
      top
      :color="snackbar.color"
      elevation="10"
      style="z-index: 9999 !important"
    >
      <div class="d-flex px-2">
        <v-icon left class="mr-4">{{ snackbar.icon }}</v-icon>
        <h6 class="alerta">
          {{ snackbar.mensaje }}
        </h6>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="cerrarAlerta()">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <app-side-bar v-if="authValid"></app-side-bar>
    <app-toolbar v-if="authValid"></app-toolbar>

    <v-idle
      v-if="prod && authValid"
      v-show="false"
      @idle="onidle"
      @remind="onremind"
      :loop="true"
      :reminders="[60 * 4, 60 * 2, 60 * 1, 30]"
      :wait="5"
      :duration="60 * 10"
    />
    <global-loader />
    <v-main>
      <router-view />
    </v-main>
    <pop-up-dialog v-if="dialogoAniversario" />

    <app-footer></app-footer>
  </v-app>
</template>

<script>
import SideBarVue from "./components/app/SideBar.vue";
import FooterVue from "./components/app/FooterApp.vue";
import ToolbarVue from "./components/app/ToolbarApp.vue";
import PopUpDialog from "@/components/perfil/PopUpDialog.vue";

import auth from "./services/auth";
import { mapState, mapActions } from "vuex";
import GlobalLoader from "./components/app/GlobalLoader.vue";
import { socketConnect, socketDisconnect } from "./config/socket";
import config from "./config/configBase";
export default {
  name: "App",
  metaInfo: { title: "Sistema Ticket" },
  components: {
    "app-side-bar": SideBarVue,
    "app-footer": FooterVue,
    "app-toolbar": ToolbarVue,
    GlobalLoader,
    PopUpDialog,
  },
  data() {
    return {
      bgImg: config.bgImg,
      prod: process.env.NODE_ENV === "production",
      colorBar: config.colorBar,
      btnColor: config.btnColor,
      dark: config.dark,
    };
  },
  computed: {
    ...mapState(["snackbar", "dialogoAniversario"]),
    rutaActual() {
      return this.$route?.name;
    },
    authValid() {
      let noPermitidas = ["login", "crear-contrasena", "mantencion"];
      return this.rutaActual && !noPermitidas.includes(this.rutaActual);
    },
  },
  created() {
    socketConnect();
    window.addEventListener("beforeunload", () => {
      socketDisconnect();
    });
  },
  methods: {
    ...mapActions(["mostrarAlerta", "cerrarAlerta"]),
    onidle() {
      auth.cerrarSesion();
      alert("Se cerró su sesión por inactividad");
    },
    onremind(time) {
      let reminder = time >= 60 ? time / 60 + " minutos" : time + " segundos";
      this.mostrarAlerta({
        mensaje: "Se va a cerrar su sesión por inactividad en " + reminder,
        color: "warning",
      });
    },
  },
};
</script>

<style lang="css">
.blur-bg {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(1px);
  height: 100%;
  width: 100%;
}
.icon-menu .v-list-item__icon {
  align-self: center !important;
}
.nav-props .v-list-item .v-list-item__title {
  font-size: 0.8rem !important;
}
.nav-props .v-list-item {
  min-height: 45px !important;
  height: 45px !important;
  margin-bottom: 1px !important;
  border-radius: 0px !important;
}
.nav-props .v-list--nav .v-list-item:before {
  border-radius: 0px !important;
}
.nav-props .v-subheader {
  font-size: 0.8rem !important;
}
.nav-props .v-list-item__content {
  padding: 6px 0px !important;
}
.nav-props .v-navigation-drawer__content {
  scrollbar-width: thin;
}
.alerta {
  font-family: "Open Sans", sans-serif;
  font-weight: 300 !important;
  font-size: 18px;
}
.primaryGradient {
  background-image: linear-gradient(
    to right,
    #4285f4 0%,
    #2838c3 51%,
    #4285f4 100%
  );
}
.v-slide-group__prev {
  display: none !important;
}
.v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon {
  margin: 0;
  min-width: 0px !important;
}
.titulo {
  word-break: normal;
  font-weight: 300;
}
.v-data-table-header th {
  padding-top: 10px !important;
  vertical-align: top !important;
}

.lato {
  font-family: "Lato", sans-serif;
}
.ql-editor {
  padding: 0px 0px !important;
  min-height: 5px !important;
}
.texto-25 {
  font-size: 25px;
  line-height: 25px;
}
.texto-20 {
  font-size: 20px;
  line-height: 20px;
}
.v-dialog {
  margin: 0px !important;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 98% !important;
}
.format-table td:first-child {
  border-left: thin solid rgba(63, 81, 181, 0.3) !important;
}
.format-table td {
  border-right: thin solid rgba(63, 81, 181, 0.3) !important;
  border-bottom: thin solid rgba(63, 81, 181, 0.3) !important;
}
.format-table th {
  border-right: thin solid rgba(63, 81, 181, 0.3) !important;
  border-top: thin solid rgba(63, 81, 181, 0.3) !important;
  border-bottom: thin solid rgba(63, 81, 181, 0.3) !important;
  background-color: rgba(63, 81, 181, 0.9) !important;
  color: white !important;
  font-size: 0.9rem !important;
  font-weight: 400;
  height: auto;
  padding-right: 0px !important;
}
.format-table th:first-child {
  border-left: thin solid rgba(63, 81, 181, 0.3) !important;
}

.format-table-ticket td {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.format-table-ticket th {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
  border-top: thin solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
  /*background-color: rgba(63, 81, 181, 0.9) !important;
  color: white !important;
  font-size: 0.8rem !important;
  font-weight: 400;
  height: auto;*/
}
.format-table-ticket th:first-child {
  border-left: thin solid rgba(0, 0, 0, 0.12) !important;
}

.format-table-ticket td:first-child {
  border-left: thin solid rgba(0, 0, 0, 0.12) !important;
}
.list-dense .v-list-item__content {
  padding: 4px 0px !important;
}

.mini-class .v-navigation-drawer__content {
  overflow: visible !important;
}
.mini-class {
  overflow: visible !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 0.825rem !important;
}

.header-style th {
  background-color: var(--v-primary-base) !important;
  color: white !important;
  font-size: 0.8rem !important;
  font-weight: 400;
  padding-left: 4px !important;
  padding-right: 4px !important;

  text-wrap: balance;
  word-wrap: normal !important;
  /*white-space: nowrap;*/
  /*display: flex;
  flex-wrap: nowrap;*/
}
.header-style th i {
  color: white !important;
}
.header-style th:first-child {
  border-top-left-radius: 5px 5px !important;
}
.header-style th:last-child {
  border-top-right-radius: 5px 5px !important;
}

.header-style td:first-child {
  border-left: thin solid rgba(0, 0, 0, 0.12) !important;
}
.header-style td {
  border-right: thin solid rgba(0, 0, 0, 0.12) !important;
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
  padding: 0px 10px !important;
}

.bebas-font {
  font-family: "Bebas Neue", sans-serif !important;
}
.metro-font {
  font-family: "Metropolis", sans-serif !important;
}
.monserrat-font {
  font-family: "Montserrat", sans-serif !important;
}

.popins-font {
  font-family: "Poppins", sans-serif !important;
}

.scale-hover {
  transition: 0.3s ease-in !important;
}

.scale-hover:hover {
  transform: scale(1.05);
}

.click {
  cursor: pointer !important;
}
.right-tooltip::before {
  content: "";
  position: absolute;
  top: 50%;
  left: -15px; /* Ajusta esto para la distancia lateral de la punta */
  margin-top: -20px; /* Ajusta esto para la posición vertical de la punta */
  border-width: 10px 10px 10px 0;
  border-style: solid;
  border-color: transparent var(--v-primary-base) transparent transparent; /* Ajusta aquí para el color del fondo */
}
.full-right-tooltip::before {
  content: "";
  position: absolute;
  top: 100%;
  left: -15px; /* Ajusta esto para la distancia lateral de la punta */
  margin-top: -20px; /* Ajusta esto para la posición vertical de la punta */
  border-width: 10px 10px 10px 0;
  border-style: solid;
  /*border-color: transparent var(--v-primary-base) transparent transparent;*/ /* Ajusta aquí para el color del fondo */
  border-color: transparent #ffc107 transparent transparent; /* Ajusta aquí para el color del fondo */
}

.top-tooltip::before {
  content: "";
  position: absolute;
  top: -25px; /* Coloca la flecha al revés y ajusta esta propiedad */
  left: 50%; /* Ajusta esto para la distancia lateral de la punta */
  margin-bottom: -20px; /* Ajusta esto para la posición vertical de la punta */
  border-width: 10px 10px 10px 10px; /* Cambia la configuración del borde */
  border-style: solid;
  border-color: transparent transparent var(--v-primary-base) transparent; /* Ajusta aquí para el color del fondo */
}
.top-right-tooltip::before {
  content: "";
  position: absolute;
  top: -25px; /* Coloca la flecha al revés y ajusta esta propiedad */
  right: 5%; /* Ajusta esto para la distancia lateral de la punta */
  margin-bottom: -20px; /* Ajusta esto para la posición vertical de la punta */
  border-width: 10px 10px 10px 10px; /* Cambia la configuración del borde */
  border-style: solid;
  border-color: transparent transparent var(--v-primary-base) transparent; /* Ajusta aquí para el color del fondo */
}

/*.theme--dark.v-skeleton-loader .v-skeleton-loader__image {
  background: rgba(255, 255, 255, 0.8) !important;
}*/

.x-spreadsheet {
  width: fit-content;
}
/*.x-spreadsheet .x-spreadsheet-toolbar {
  display: none !important;
}*/
.x-spreadsheet .x-spreadsheet-bottombar .x-spreadsheet-menu li:first-child {
  display: none !important;
}
.x-spreadsheet-contextmenu {
  display: none !important;
}
.x-spreadsheet div[data-tooltip="Font"] {
  display: none !important;
}
.x-spreadsheet div[data-tooltip="Font size"] {
  display: none !important;
}
.x-spreadsheet div[data-tooltip="Print (Ctrl+P)"] {
  display: none !important;
}
.x-spreadsheet div[data-tooltip="Paint format"] {
  display: none !important;
}
.x-spreadsheet div[data-tooltip="Format"] {
  display: none !important;
}
.x-spreadsheet div[data-tooltip="Merge cells"] {
  display: none !important;
}
.x-spreadsheet div[data-tooltip="Functions"] {
  display: none !important;
}
.flat-chip .theme--dark.v-chip:hover::before {
  opacity: 0 !important;
}
.file-hint .v-messages__message {
  white-space: pre !important;
  padding-bottom: 2px;
}
.abs-left {
  position: absolute !important;
  left: 0px;
  padding-left: 5px;
}
.titulo-ayuda {
  font-size: 14px;
}
.custom-list-item .v-list-item__content {
  padding: 6px 0px !important;
}
.imp-chip {
  width: 100%;
  height: 18px;
  font-size: 10px;
  padding: 0px 0px 0px 4px;
  font-weight: 500 !important;
}
.text-skeleton .v-skeleton-loader__text {
  margin-bottom: 0px !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}
.custom-list-html {
  list-style-type: none; /* Eliminamos el marcador por defecto */
  padding-left: 16px !important;
}

.custom-list-html li {
  counter-increment: list-item; /* Incrementamos el contador para cada elemento */
}

.custom-list-html li:before {
  content: counter(list-item) ") "; /* Agregamos el número seguido de un paréntesis */
  margin-left: -16px;
}
.badge-off .v-badge__badge {
  pointer-events: none !important;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  -webkit-background-clip: text !important;
  background-clip: text !important;
  font-size: initial !important;
  color: var(--inputText) !important;
  -webkit-text-fill-color: var(--inputText) !important;
}
.glass {
  box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.2) !important;
  background-color: var(--colorBar) !important;
  backdrop-filter: blur(15px) !important;
}

.glassApp {
  box-shadow: 0 0 1rem 0 rgba(51, 51, 51, 0.2) !important;
  background-color: rgba(255, 255, 255, 0.87) !important;
  backdrop-filter: blur(10px) !important;
}
.snow-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.snowflake {
  position: absolute;
  top: -10px;
  font-size: 12px;
  opacity: 0.8;
  animation: fall linear infinite;
  color: white;
  /* Un tono azul claro */
}

/* Animación de caída */
@keyframes fall {
  0% {
    transform: translateY(0) rotate(0deg);
  }

  100% {
    transform: translateY(100vh) rotate(360deg);
  }
}

.skeleton-bold-text .v-skeleton-loader__text {
  height: 15px !important;
}

.grecaptcha-badge {
  z-index: 99999 !important;
  margin-bottom: 40px !important;
}

.alert-dense .v-alert__icon {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
</style>
